import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ADMIN_CONSTANT, ResponseBody } from 'src/app/app.model';
import { AppService } from 'src/app/app.service';
@Injectable({
  providedIn: 'root'
})

export class LandingService {
  masterData: Subject<any> = new Subject<any>();
  RunCycleListData: Subject<any[]> = new Subject<any[]>();
  constructor(private router: Router, private service: AppService) { }

  onDashboardDataFetch(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'UserAdminDashboardFetch',
      '',
      payload,
      this.service.userData,
    );
  }
  onCourseMeritListFetch(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'MeritListFetch',
      '',
      payload,
      this.service.userData,
    );
  }
  onDashboardCollegeDataFetch(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'UserAdminDashboardCollege',
      '',
      payload,
      this.service.userData,
    );
  }
  onDashboardCourseDataFetch(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'UserAdminDashboardCourse',
      '',
      payload,
      this.service.userData,
    );
  }

  onUserAdminDashboardRunFetch(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'UserAdminDashboardRunFetch',
      '',
      payload,
      this.service.userData,
    );
  }
  onCollegeAdmissionList(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'CollegeAdmissionList',
      '',
      payload,
      this.service.userData,
      false
    );
  }
  onGetVacacyList(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'GetVacacyList',
      '',
      payload,
      this.service.userData,
      false
    );
  }
  onCourseAdmissionDetail(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'CourseAdmissionDetail',
      '',
      payload,
      this.service.userData,
      false
    );
  }
  onUserAdminDashboardRunCollege(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'UserAdminDashboardRunCollege',
      '',
      payload,
      this.service.userData,
    );
  }

  onUserAdminDashboardRunCourse(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'UserAdminDashboardRunCourse',
      '',
      payload,
      this.service.userData,
    );
  }

  onExecuteAllocationProcess(payload: any, subOperationKey: string): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'ExecuteAllocationProcess',
      subOperationKey,
      payload,
      this.service.userData,
    );
  }
  getRunCycleDashboardList(): void {
    this.onRunCycleDashboard({
      ObjectType: ADMIN_CONSTANT.CONFIG_RUNCYCLE_DASHBOARD,
    }).subscribe(
      (response) => {
        if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
          this.RunCycleListData.next(response.Body.BusinessData.Collection);
          this.masterData.next(response.Body.MasterData);
        } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
          this.service.showToast(response.Error.ErrorMessage);
          this.router.navigate(['dashboard', 'home'], {
            replaceUrl: true,
          });
        }
      },
      (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
    );
  }
  onRunCycleDashboard(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'RunCycleDashboard',
      '',
      payload,
      this.service.userData,
    );
  }
  ongenerateMeritList(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'MeritListGenerate',
      '',
      payload,
      this.service.userData,
    );
  }
  onpublishMeritList(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'MeritListPublish',
      '',
      payload,
      this.service.userData,
    );
  }
  addNewRuncycle(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'RunCycleAdd',
      '',
      payload,
      this.service.userData,
    );
  }
  addNewIteration(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'RunIterationAdd',
      '',
      payload,
      this.service.userData,
    );
  }
  ongenerateallocationList(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'AllocationListGenerate',
      '',
      payload,
      this.service.userData,
    );
  }
  onpublishallocationList(payload: any): Observable<ResponseBody> {
    return this.service.requestAPI(
      true,
      'AllocationListPublish',
      '',
      payload,
      this.service.userData,
    );
  }
}
